<template>
    <div class="file-input-container" @click="SelectFile">
        <form :ref="'fi_form_' + id">
            <input type="file" class="hidden" :ref="'fi_'+ id" @change="ChangeFilename">
        </form>
        
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor" v-if="render_filename === null">
            <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
        </svg>
        <p class="file-input-text">{{render_filename !== null ? render_filename : "Файл не выбран"}}</p>
        <button type="button" class="file-input-button" v-if="render_filename !== null" @click="Clear">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        filename: {
            type: String,
            default: null
        },
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            render_filename: null,
            is_changed: false,
        }
    },
    methods: {
        SelectFile() {
            this.$refs[`fi_${this.id}`].click()
        },
        ChangeFilename(e) {
            let data = e.target.files

            if (data.length > 0) {
                this.render_filename = data[0].name
                this.is_changed = true
            }
        },
        IsChanged() {
            return this.is_changed
        },
        ResetIsChanged() {
            this.is_changed = false
        },
        GetFileData() {
            return this.$refs[`fi_${this.id}`].files
        },
        Clear(e) {
            e.stopPropagation()
            this.render_filename = null
            this.$refs[`fi_form_${this.id}`].reset()
            this.is_changed = true
        }
    },
    watch: {
        filename(newVal, oldVal) {
            this.render_filename = newVal.trim() === "" ? null : newVal
        }
    }
}
</script>